import z from "zod";

const subscriptionCancelledDataSchema = z.object({
    ip: z.string(),
    reason: z.string(),
    chargeId: z.string(),
});

export { subscriptionCancelledDataSchema };
